<template>
    <div class="past-events_toggle / flex">
        <VJoyButton
            variant="ghost"
            :icon="isActivityHistoryVisible ? 'chevron-up' : 'chevron-down'"
            icon-position="right"
            size="small"
            data-testid="show-project-history-button"
            @click="handleToggleHistory"
        >
            {{
                isActivityHistoryVisible
                    ? t('projectclient.projectview.activity.past.events.actions.hide')
                    : t('projectclient.projectview.activity.past.events.actions.show')
            }}
        </VJoyButton>
    </div>

    <div v-if="isActivityHistoryVisible" class="past-events_list">
        <PastEventItem v-for="(event, index) of pastEvents" :key="index" :index="index" :event="event" />
    </div>
</template>

<script setup lang="ts">
    import {ref} from 'vue';
    import {useTranslation} from '#imports';
    import {VJoyButton} from '@maltjoy/core-vue';
    import type {ProjectActivityResourcePastEventsInner} from '@api';
    import {PastEventItem} from './index';

    defineProps<{
        pastEvents?: ProjectActivityResourcePastEventsInner[];
    }>();

    const {t} = useTranslation();

    const isActivityHistoryVisible = ref(true);

    function handleToggleHistory() {
        isActivityHistoryVisible.value = !isActivityHistoryVisible.value;
    }
</script>

<style lang="scss" scoped>
    .past-events {
        &_toggle {
            width: 100%;
            justify-content: center;
        }

        &_list {
            width: 100%;
        }
    }
</style>
